export const homeHeaderPhoneBg = (
    <svg xmlns="http://www.w3.org/2000/svg" width="338" height="259" viewBox="0 0 338 259" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.5 45.6753C2.5 20.8225 22.6472 0.675293 47.5 0.675293H291.296C316.149 0.675293 336.296 20.8225 336.296 45.6753V182.781H338V243.031H336.296V258.999H334.296V45.6753C334.296 21.9271 315.044 2.67529 291.296 2.67529H47.5C23.7518 2.67529 4.5 21.927 4.5 45.6753V258.937H2.75H2.5H0.75V226.281H2.5V187.281H0.75V101.732H2.5V45.6753ZM19.1643 50.2149C14.5554 55.3224 12.5 61.6181 12.5 65.9824V258.937H10.5V65.9824C10.5 61.0968 12.7571 54.33 17.6795 48.875C22.6321 43.3864 30.2825 39.2267 41.0178 39.6074H303.75H303.812L303.873 39.615C309.481 39.6074 314.304 42.036 319.543 46.0916C324.817 50.1733 329.073 56.4463 329.125 65.6018C329.225 83.2059 329.167 195.597 329.125 259L327.125 258.999C327.167 195.589 327.225 83.209 327.125 65.6131C327.077 57.1686 323.188 51.4416 318.319 47.6732C313.442 43.8984 309.132 41.6074 303.688 41.6074H41H40.982L40.9641 41.6068C30.8339 41.2428 23.7401 45.144 19.1643 50.2149ZM60.375 19.6074C60.375 22.1963 58.2763 24.2949 55.6875 24.2949C53.0987 24.2949 51 22.1963 51 19.6074C51 17.0186 53.0987 14.9199 55.6875 14.9199C58.2763 14.9199 60.375 17.0186 60.375 19.6074ZM100.969 24.1699C103.627 24.1699 105.781 22.0153 105.781 19.3574C105.781 16.6996 103.627 14.5449 100.969 14.5449C98.3109 14.5449 96.1562 16.6996 96.1562 19.3574C96.1562 22.0153 98.3109 24.1699 100.969 24.1699ZM103.781 19.3574C103.781 20.9107 102.522 22.1699 100.969 22.1699C99.4155 22.1699 98.1562 20.9107 98.1562 19.3574C98.1562 17.8041 99.4155 16.5449 100.969 16.5449C102.522 16.5449 103.781 17.8041 103.781 19.3574ZM120.531 19.3574C120.531 21.3595 118.908 22.9824 116.906 22.9824C114.904 22.9824 113.281 21.3595 113.281 19.3574C113.281 17.3554 114.904 15.7324 116.906 15.7324C118.908 15.7324 120.531 17.3554 120.531 19.3574ZM116.906 20.9824C117.804 20.9824 118.531 20.2549 118.531 19.3574C118.531 18.46 117.804 17.7324 116.906 17.7324C116.009 17.7324 115.281 18.46 115.281 19.3574C115.281 20.2549 116.009 20.9824 116.906 20.9824ZM262.875 24.2949C265.464 24.2949 267.562 22.1963 267.562 19.6074C267.562 17.0186 265.464 14.9199 262.875 14.9199C260.286 14.9199 258.188 17.0186 258.188 19.6074C258.188 22.1963 260.286 24.2949 262.875 24.2949ZM238.156 19.3887C238.156 21.477 236.463 23.1699 234.375 23.1699C232.287 23.1699 230.594 21.477 230.594 19.3887C230.594 17.3003 232.287 15.6074 234.375 15.6074C236.463 15.6074 238.156 17.3003 238.156 19.3887ZM234.375 27.5762C238.897 27.5762 242.562 23.9105 242.562 19.3887C242.562 14.8668 238.897 11.2012 234.375 11.2012C229.853 11.2012 226.188 14.8668 226.188 19.3887C226.188 23.9105 229.853 27.5762 234.375 27.5762ZM240.562 19.3887C240.562 22.8059 237.792 25.5762 234.375 25.5762C230.958 25.5762 228.188 22.8059 228.188 19.3887C228.188 15.9714 230.958 13.2012 234.375 13.2012C237.792 13.2012 240.562 15.9714 240.562 19.3887ZM82.4375 19.6074C82.4375 23.577 79.2195 26.7949 75.25 26.7949C71.2805 26.7949 68.0625 23.577 68.0625 19.6074C68.0625 15.6379 71.2805 12.4199 75.25 12.4199C79.2195 12.4199 82.4375 15.6379 82.4375 19.6074ZM150.188 16.3574C148.255 16.3574 146.688 17.9244 146.688 19.8574C146.688 21.7904 148.255 23.3574 150.188 23.3574H194.125C196.058 23.3574 197.625 21.7904 197.625 19.8574C197.625 17.9244 196.058 16.3574 194.125 16.3574H150.188Z" fill="white" />
    </svg>
)

export const backTopBtn = (<svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='12'
    viewBox='0 0 22 12'
    fill='none'
>
    <path
        d='M1.89844 10.6333L10.6376 1.86387C11.0338 1.46633 11.6795 1.4726 12.0678 1.87774L20.8125 11'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
    />
</svg>)

export const chatSVG = (<svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
>
    <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.0762 16.9424C15.2624 17.6591 14.3028 18.2118 13.246 18.558C12.4564 18.8192 11.6062 18.9588 10.7255 18.9588H2.17404C2.17404 18.9588 2.16797 18.9588 2.16797 18.9528V11.2273C2.16797 6.53857 5.96997 2.73657 10.6587 2.73657C12.9059 2.73657 14.9527 3.64152 16.4346 5.1113C17.9408 6.60538 18.87 8.68251 18.8336 10.9722C18.8093 12.4724 18.3781 13.8753 17.6493 15.0718C17.3152 15.6184 16.9144 16.1286 16.4649 16.578C16.343 16.7 16.221 16.8109 16.0936 16.9266L16.0936 16.9267L16.0762 16.9424ZM14.2156 11.5761C14.4646 11.337 14.4726 10.9413 14.2335 10.6924C13.9944 10.4434 13.5988 10.4354 13.3498 10.6744C12.6595 11.3373 11.6095 11.7286 10.5191 11.7468C9.43169 11.7649 8.38086 11.4113 7.66478 10.6861C7.42226 10.4405 7.02654 10.438 6.78092 10.6805C6.5353 10.923 6.53279 11.3188 6.77532 11.5644C7.78044 12.5823 9.1879 13.0191 10.54 12.9966C11.8891 12.9741 13.2598 12.4938 14.2156 11.5761Z'
        fill='white'
    />
</svg>)

export const downloadApp = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="42" viewBox="0 0 25 42" fill="none">
        <path d="M0.875 4.15252C0.875 2.15167 2.49701 0.529663 4.49786 0.529663H21.2521C23.253 0.529663 24.875 2.15167 24.875 4.15252V35.0021C24.875 37.003 23.253 38.625 21.2521 38.625H4.49786C2.49701 38.625 0.875 37.003 0.875 35.0021V4.15252Z" fill="#2378E5" />
        <path d="M12.6542 12.5V21.941M12.6542 21.941L8.59375 17.6236M12.6542 21.941L16.8595 17.6236" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M8.32812 33.7588H17.4219" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

export const cameraSVG = (<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M7.29238 5.73079C7.27339 7.00347 6.24764 8.02922 4.99395 8.02922C3.72127 8.02922 2.69552 7.00347 2.69552 5.73079C2.69552 4.4581 3.72127 3.43236 4.99395 3.43236C6.26664 3.43236 7.29238 4.4581 7.29238 5.73079ZM3.22739 0.811009C3.22739 1.13393 3.47433 1.38087 3.79725 1.38087H6.19065C6.51357 1.38087 6.77951 1.13393 6.77951 0.811009C6.77951 0.488089 6.53257 0.24115 6.20965 0.24115H3.79725C3.47433 0.24115 3.22739 0.488089 3.22739 0.811009ZM9.91373 3.14743C9.91373 2.4636 9.38186 1.91274 8.69803 1.91274H1.28987C0.606039 1.91274 0.0551758 2.4636 0.0551758 3.14743V8.33314C0.0551758 9.01697 0.606039 9.54884 1.28987 9.54884H8.69803C9.36287 9.54884 9.91373 8.99798 9.91373 8.33314V3.14743Z" fill="#B8B8B8" />
</svg>)



export const EmptyIndustrySvg = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="140"
        height="140"
        viewBox="0 0 140 140"
        fill="none"
    >
        <circle cx="70.001" cy="69.9998" r="70" fill="#E5EEFE" />
        <mask id="mask0_2137_661" maskUnits="userSpaceOnUse" x="0" y="0" width="140" height="141">
            <circle cx="70" cy="70.0002" r="70" fill="#E5EEFE" />
        </mask>
        <g mask="url(#mask0_2137_661)">
            <path
                d="M71.124 51.019L74.6026 41.6595C75.2099 40.638 76.0602 38.2305 74.6026 36.7727C72.7805 34.9505 72.3661 32.3 74.6026 30.1465C76.8391 27.993 81.8087 28.987 82.8026 29.5667C83.7966 30.1465 87.441 32.1344 85.3703 35.199C83.2996 38.2636 82.3057 37.7667 82.2229 40.9141C82.1566 43.4321 82.9131 49.9147 83.2996 52.8413"
                stroke="#CADCFD"
                strokeWidth="2.48094"
            />
            <path
                d="M114.29 72.2011V40.446H32.3857L44.3907 53.6128L42.8417 90.4021L54.6528 110.733L80.986 139.777C92.0873 140.294 114.484 140.242 115.258 135.905C116.226 130.483 116.033 114.025 115.258 105.311C114.484 96.5981 114.29 80.9143 114.29 72.2011Z"
                fill="url(#paint0_linear_2137_661)"
            />
            <path
                d="M105.48 136.486C113.845 126.573 112.548 68.1999 111.773 42.1892L100.252 47.8049L62.6885 112.864C73.4026 119.06 96.9606 132.459 105.48 136.486Z"
                fill="url(#paint1_linear_2137_661)"
            />
            <path
                d="M102.285 136.486C110.65 126.572 110.563 69.652 109.788 43.6414L97.0569 47.8045L59.4932 112.864C70.2072 119.06 93.7653 132.459 102.285 136.486Z"
                fill="url(#paint2_linear_2137_661)"
            />
            <path
                d="M97.6385 136.486C106.003 126.572 106.545 72.072 105.771 46.0613L92.4104 47.804L54.8467 112.863C65.5608 119.059 89.1188 132.458 97.6385 136.486Z"
                fill="url(#paint3_linear_2137_661)"
            />
            <path
                d="M31.4178 82.2701V40.8337L101.704 48.5789C101.963 55.5495 102.324 75.1833 101.704 97.954C100.93 126.417 94.5402 131.839 80.9863 139.584C69.9495 133.581 53.4911 134.356 32.9666 131.839C17.1876 129.904 12.442 124.675 8.37598 122.157C23.5491 114.142 32.9666 100.277 31.4178 82.2701Z"
                fill="url(#paint4_linear_2137_661)"
            />
            <path
                d="M42.0659 33.7664L31.3193 40.737L101.897 48.6757L114.386 40.5433L42.0659 33.7664Z"
                fill="url(#paint5_linear_2137_661)"
            />
            <path
                d="M55.9108 33.1853L49.3271 35.9928L83.4059 38.8973L90.6669 35.9928L55.9108 33.1853Z"
                fill="url(#paint6_linear_2137_661)"
            />
            <path
                d="M51.0223 50.9022L49.4248 36.0896L83.5034 39.0909L84.9556 55.4524L51.0223 50.9022Z"
                fill="url(#paint7_linear_2137_661)"
            />
            <path
                d="M58.499 50.8027L62.565 39.8627C63.2749 38.6687 64.2687 35.8546 62.565 34.1507C60.4352 32.0208 59.9508 28.9228 62.565 26.4056C65.1791 23.8884 70.9879 25.0503 72.1497 25.728C73.3115 26.4056 77.5713 28.7292 75.1509 32.3113C72.7306 35.8934 71.5688 35.3126 71.472 38.9915C71.3946 41.9346 72.2788 49.5119 72.7306 52.9327"
                stroke="#6294EA"
                strokeWidth="2.48094"
            />
            <path
                d="M48.7951 49.4021C48.4855 47.5433 50.344 47.1431 51.3119 47.1753C60.4125 48.4016 79.4752 50.9317 82.9218 51.2415C82.1473 53.7586 83.6641 55.2915 84.5193 55.7433L51.3119 51.5803C50.602 51.6288 49.1047 51.2609 48.7951 49.4021Z"
                fill="url(#paint8_linear_2137_661)"
            />
            <path d="M90.5955 36.0173L85.9971 37.8568L90.5955 38.3408V36.0173Z" fill="#316ACB" />
        </g>
        <path
            d="M31.4217 82.2701V40.8337L101.708 48.5789C101.967 55.5495 102.328 75.1833 101.708 97.954C100.934 126.417 94.5441 131.839 80.9902 139.584C69.9534 133.581 53.495 134.356 32.9705 131.839C17.1915 129.904 12.4459 124.675 8.37988 122.157C23.553 114.142 32.9705 100.277 31.4217 82.2701Z"
            fill="url(#paint9_linear_2137_661)"
        />
        <g filter="url(#filter0_d_2137_661)">
            <path
                d="M18.835 76.7641V65.8401C18.835 63.6958 20.7588 62.0637 22.8744 62.4132L81.8988 72.1651C84.0549 72.5213 85.6365 74.3856 85.6365 76.571V86.5891C85.6365 89.3792 83.1065 91.4861 80.3625 90.981L21.6795 80.18C20.0315 79.8767 18.835 78.4398 18.835 76.7641Z"
                fill="#E5EEFF"
            />
        </g>
        <g filter="url(#filter1_d_2137_661)">
            <path
                d="M18.835 97.5425V89.9955C18.835 88.4639 20.2091 87.2981 21.7203 87.5478L63.5197 94.4537C64.7176 94.6516 65.5963 95.6874 65.5963 96.9015V105.236C65.5963 106.786 64.1907 107.957 62.6662 107.676L20.8668 99.9825C19.6896 99.7658 18.835 98.7395 18.835 97.5425Z"
                fill="#76A6F8"
            />
        </g>
        <path
            d="M22.0791 75.764V67.0586C22.0791 66.1312 22.9179 65.4296 23.8306 65.5934L32.1808 67.0922C32.8902 67.2195 33.4064 67.8367 33.4064 68.5574V77.3698C33.4064 78.3047 32.5548 79.0081 31.6367 78.8316L23.2866 77.2258C22.5857 77.091 22.0791 76.4777 22.0791 75.764Z"
            fill="#BED5FB"
        />
        <path
            d="M36.6494 71.8606V69.1305C36.6494 68.5112 37.2103 68.0433 37.8195 68.1541L79.9818 75.8285C80.4536 75.9143 80.7965 76.3253 80.7965 76.8048V79.7198C80.7965 80.3407 80.2327 80.8092 79.6223 80.6954L37.4599 72.8362C36.9901 72.7486 36.6494 72.3386 36.6494 71.8606Z"
            fill="#BED5FB"
        />
        <path
            d="M36.6494 78.3595V75.6284C36.6494 75.0053 37.2169 74.5364 37.8288 74.6538L55.0132 77.9519C55.4806 78.0416 55.8185 78.4505 55.8185 78.9265V81.831C55.8185 82.4581 55.2442 82.9279 54.6296 82.8038L37.4453 79.3322C36.9823 79.2387 36.6494 78.8318 36.6494 78.3595Z"
            fill="#BED5FB"
        />
        <defs>
            <filter
                id="filter0_d_2137_661"
                x="15.5601"
                y="61.0759"
                width="73.3514"
                height="35.2399"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.98475" />
                <feGaussianBlur stdDeviation="1.63742" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.271026 0 0 0 0 0.512158 0 0 0 0 0.926904 0 0 0 0.29 0"
                />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2137_661" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_2137_661"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_2137_661"
                x="15.0639"
                y="85.7276"
                width="54.3038"
                height="27.7458"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.98475" />
                <feGaussianBlur stdDeviation="1.88551" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.368627 0 0 0 0 0.584314 0 0 0 0 0.964706 0 0 0 0.4 0"
                />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2137_661" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_2137_661"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_2137_661"
                x1="74.1497"
                y1="40.446"
                x2="89.1184"
                y2="105.311"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#4F80D7" />
                <stop offset="1" stopColor="#83A9EA" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_2137_661"
                x1="96.6703"
                y1="44.319"
                x2="102.673"
                y2="125.255"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5E8DDE" />
                <stop offset="1" stopColor="#7BA3E8" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_2137_661"
                x1="84.8064"
                y1="48.8105"
                x2="97.6378"
                y2="130.096"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5284DA" />
                <stop offset="1" stopColor="#9CBDF7" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_2137_661"
                x1="80.4361"
                y1="51.0956"
                x2="92.4969"
                y2="130.401"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5284DA" />
                <stop offset="1" stopColor="#B0CDFF" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_2137_661"
                x1="55.2113"
                y1="40.8337"
                x2="34.1282"
                y2="111.508"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#397BF2" />
                <stop offset="1" stopColor="#9EC1FD" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_2137_661"
                x1="31.3193"
                y1="41.221"
                x2="114.386"
                y2="41.221"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ABC8FB" />
                <stop offset="1" stopColor="#71A2F7" />
            </linearGradient>
            <linearGradient
                id="paint6_linear_2137_661"
                x1="49.3271"
                y1="36.0413"
                x2="90.6669"
                y2="36.0413"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#ABC8FB" />
                <stop offset="1" stopColor="#5C94F6" />
            </linearGradient>
            <linearGradient
                id="paint7_linear_2137_661"
                x1="56.2017"
                y1="38.7036"
                x2="67.1902"
                y2="55.4524"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#699CF4" />
                <stop offset="1" stopColor="#225ABB" />
            </linearGradient>
            <linearGradient
                id="paint8_linear_2137_661"
                x1="48.7607"
                y1="51.4585"
                x2="84.5193"
                y2="51.4585"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#98BDFC" />
                <stop offset="1" stopColor="#4F80D4" />
            </linearGradient>
            <linearGradient
                id="paint9_linear_2137_661"
                x1="55.2152"
                y1="40.8337"
                x2="34.1321"
                y2="111.508"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#397BF2" />
                <stop offset="1" stopColor="#9EC1FD" />
            </linearGradient>
        </defs>
    </svg>
)


export const FindJobsSvg = () => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: 8 }}>
        <path id="Vector 4238 (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M0.292908 1.85354L1.70712 0.439331L6.00001 4.73222L10.2929 0.439331L11.7071 1.85354L6.00001 7.56065L0.292908 1.85354Z" fill="black" fillOpacity="0.7" />
    </svg>
)

export const cellHoneIcon = (<svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" viewBox="0 0 18 24" fill="none">
    <rect x="0.75" y="0.75" width="16.5" height="22.5" rx="1.25" stroke="black" strokeWidth="1.5" />
    <rect x="6" y="3" width="6" height="1.5" rx="0.75" fill="black" />
    <circle cx="9" cy="20" r="1" fill="black" />
</svg>)

export const WhiteLogo = (width = 144, height = 36) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 144 36" fill="none">
        <path d="M89.4124 35.0847C87.6884 35.0847 86.5258 34.8025 85.6436 34.4797L86.6865 30.086C87.2792 30.2947 87.9021 30.4038 88.5302 30.4088C90.4532 30.4088 91.0156 29.1194 91.0156 26.5812V9.66895H96.9085V26.4258C96.9085 31.2605 95.0632 35.0847 89.4124 35.0847Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M110.325 32.1686C117.351 32.1686 121.598 27.001 121.598 20.9867C121.598 14.9725 117.348 9.88086 110.325 9.88086C103.302 9.88086 99.126 14.9759 99.126 20.9867C99.126 26.9976 103.373 32.1686 110.325 32.1686ZM110.325 27.1548C106.848 27.1548 104.917 24.3023 104.917 20.9851C104.917 17.6678 106.847 14.8153 110.325 14.8153C113.873 14.8153 115.807 17.6695 115.807 20.9851C115.807 24.3006 113.873 27.1548 110.325 27.1548Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M123.661 0.738281H129.185V10.4234H133.152C134.576 10.4234 135.987 10.704 137.303 11.2492C138.619 11.7944 139.815 12.5936 140.822 13.601C141.83 14.6084 142.629 15.8044 143.174 17.1206C143.72 18.4369 144 19.8476 144 21.2724C144 24.1497 142.857 26.9092 140.822 28.9437C138.788 30.9784 136.029 32.1214 133.152 32.1214H123.661V0.738281ZM129.184 25.6407V27.3221H132.337L132.335 27.3187C133.141 27.319 133.94 27.1603 134.685 26.8518C135.43 26.5434 136.106 26.0912 136.677 25.521C137.247 24.9509 137.699 24.2741 138.008 23.5291C138.316 22.7842 138.474 21.9857 138.474 21.1794C138.474 19.5512 137.827 17.9896 136.676 16.8383C135.525 15.6869 133.964 15.0401 132.335 15.0401H129.185V25.6407H129.184Z" fill="white" />
        <path d="M33.6548 32.2419C40.5625 32.2419 44.7292 27.1626 44.7292 21.2543C44.7292 15.346 40.557 10.3414 33.6548 10.3414C26.7526 10.3414 22.6577 15.3433 22.6577 21.2543C22.6577 27.1654 26.83 32.2419 33.6548 32.2419ZM33.6548 27.3146C30.2424 27.3146 28.3469 24.5125 28.3469 21.2543C28.3469 17.9962 30.2424 15.1913 33.6548 15.1913C37.1446 15.1913 39.04 17.9962 39.04 21.2543C39.04 24.5125 37.1446 27.3118 33.6548 27.3118V27.3146ZM55.6497 32.2419C61.4137 32.2419 64.7515 29.4369 64.7515 25.5736C64.7515 17.1616 52.3175 19.7372 52.3175 16.7084C52.3175 15.5699 53.6049 14.6607 55.5779 14.6607C58.1558 14.6607 60.5103 15.7993 61.7977 17.087L64.0082 13.2181C61.6032 11.3314 58.6287 10.3172 55.5724 10.3414C50.0463 10.3414 47.0069 13.3812 47.0069 16.935C47.0069 25.1177 59.3714 22.3155 59.3714 25.7228C59.3714 27.0134 58.2331 27.9337 55.8821 27.9337C53.3037 27.9337 50.1927 26.4939 48.6758 25.0541L46.3189 28.9699C48.5957 31.0287 52.0856 32.2419 55.6497 32.2419ZM75.556 32.2419C81.3196 32.2419 84.6573 29.4369 84.6573 25.5736C84.6573 17.1616 72.2238 19.7372 72.2238 16.7084C72.2238 15.5699 73.5138 14.6607 75.4868 14.6607C78.0647 14.6607 80.4162 15.7993 81.7036 17.087L83.9141 13.2181C81.5141 11.3344 78.5462 10.3194 75.4949 10.3386C69.9552 10.3386 66.9297 13.3785 66.9297 16.9323C66.9297 25.1149 79.2915 22.3127 79.2915 25.7201C79.2915 27.0106 78.1531 27.9309 75.8016 27.9309C73.2237 27.9309 70.1128 26.4911 68.5955 25.0513L66.2279 28.9699C68.4273 31.0287 71.9141 32.2419 75.556 32.2419Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 0.738281H5.5534V10.4754H9.54048C10.9728 10.4754 12.3909 10.7575 13.7142 11.3057C15.0374 11.8539 16.2397 12.6573 17.2524 13.6702C18.2652 14.6831 19.0685 15.8855 19.6166 17.2089C20.1647 18.5324 20.4468 19.9507 20.4468 21.3832C20.4468 24.2761 19.2978 27.0505 17.2524 29.0962C15.2071 31.1418 12.433 32.291 9.54048 32.291H0V0.738281ZM5.55168 25.7748V27.4658H8.72165L8.71998 27.4623C9.53053 27.4626 10.3332 27.3031 11.082 26.9929C11.8309 26.6828 12.5114 26.2282 13.0845 25.6549C13.6577 25.0817 14.1123 24.4011 14.4224 23.6522C14.7325 22.9032 14.892 22.1004 14.8917 21.2898C14.8917 19.6527 14.2415 18.0826 13.084 16.9251C11.9266 15.7675 10.3568 15.1171 8.71998 15.1171H5.5534V25.7748H5.55168Z" fill="white" />
        <path d="M90.2798 4.25423C90.2798 6.22885 91.7269 7.69006 93.7217 7.69006C94.1764 7.70113 94.6292 7.6198 95.0516 7.45109C95.4745 7.28233 95.858 7.02962 96.1798 6.70836C96.5017 6.38706 96.7548 6.00387 96.9241 5.58204C97.0933 5.16018 97.1747 4.70845 97.1635 4.25423C97.1635 2.19238 95.6801 0.818359 93.7217 0.818359C91.7269 0.818359 90.2798 2.19238 90.2798 4.25423Z" fill="#FFCE42" />
    </svg>
)
